import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';
import {
    initialReservationTypes,
    setAmenities,
    setReservationTypes,
} from './filters-utils';

const getIsMonthly = state => state.searchRequest.monthly;
const getAllSpots = state => state.spots.data;
const getCurrentFilters = state => state.filters;
const getAllReservationTypes = state => state.filters.reservationTypes;

export const getAmenities = createSelector(
    [getAllSpots, getCurrentFilters],
    (spots, filters) => {
        if (!spots.length) {
            return {};
        }

        return setAmenities({
            spots,
            filteredSpots: SpotUtils.filterV2(spots, filters),
        });
    }
);

export const getReservationTypes = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllReservationTypes],
    (isMonthly, spots, filters, reservationTypes) => {
        if (!spots.length || !isMonthly) {
            return initialReservationTypes;
        }

        return setReservationTypes({
            spots: SpotUtils.filterV2(spots, filters),
            reservationTypes,
        });
    }
);
